class nav {
	constructor() {}
	open() {
		return new Promise((resolve, reject) => {
			if(!this.isOpen) {
				this.isOpen = true;
				this.html.classList.add('navOpen');
				TweenMax.to(this.nav, 0.7, {
					opacity: 1,
					pointerEvents: 'all',
					onComplete: () => {
						resolve();
					}
				})
			}else{
				resolve();
			}
		});
	}
	close() {
		return new Promise((resolve, reject) => {
			if(this.isOpen) {
				this.isOpen = false;
				this.html.classList.remove('navOpen');
				TweenMax.to(this.nav, 0.7, {
					opacity: 0,
					pointerEvents: 'none',
					onComplete: () => {
						resolve();
					}
				})
			}else{
				resolve();
			}
		});
	}
	reset() {
		return new Promise((resolve, reject) => {
			this.isOpen = false;
			this.html.classList.remove('navOpen');
			if(this.mq.matches) {
				TweenMax.set(this.nav, {
					opacity: 0,
					pointerEvents: 'none'
				});
			}else{
				this.nav.removeAttribute('style');
			}
			resolve();
		});
	}
	init() {
		this.html = document.documentElement;
		this.mq = window.matchMedia('(max-width:750px)');
		this.btn = document.querySelector('.navTrigger');
		this.nav = document.querySelector('#gNav');
		this.navBtn = this.nav.querySelectorAll('a');
		this.isOpen = false;
		return new Promise((resolve, reject) => {
			this.btn.addEventListener('click', () => {
				if(!this.isOpen) {
					this.open();
				}else{
					this.close();
				}
			});
			let i = 0;
			while(i < this.navBtn.length) {
				this.navBtn[i].addEventListener('click', () => {
					if(this.mq.matches) {
						let t = setTimeout(() => {
							clearTimeout(t);
							t = null;
							this.close();
						}, 400)
					}
				});
				i = (i + 1) | 0;
			}
			this.mq.addListener(() => {
				this.reset();
			})
			resolve();
		});
	}
}

export default nav;


// WEBPACK FOOTER //
// ./src/assets/js/nav.js